<template>
  <el-dialog
      title="添加"
      :visible="dialogVisible"
      width="650px"
      @close="closeModal"
      center>
    <el-form :model="ruleForm" :rules="ruleData" ref="formRef" label-width="100px" class="demo-ruleForm">
      <el-form-item label="应用名称" prop="apkName">
        <el-input class="w400" v-model.trim="ruleForm.apkName" placeholder="应用名称最多100个字"
                  :maxlength="100"></el-input>
      </el-form-item>
      <el-form-item label="应用包名" prop="apkPackage">
        <el-input class="w400" v-model.trim="ruleForm.apkPackage" placeholder="应用包名最多100个字"
                  :maxlength="100"></el-input>
      </el-form-item>
      <el-form-item class="w460 text-center">
        <el-button class="w150" type="primary" @click="onSubmit()">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
        apkName: '',  // 应用名称
        apkPackage: '',  // 应用包名
      },
      ruleData: {//角色表单校验
        apkName: [
          {required: true, message: '请填写应用名称', trigger: 'blur'},
        ],
        apkPackage: [
          {required: true, message: '请填写应用包名', trigger: 'blur'},
        ],
      },
    }
  },
  methods: {
    onSubmit() {
      this.$refs['formRef'].validate(valid => {
        if (valid) {
          this.$apis.recommendAppServer.addRecommendApp(this.ruleForm).then(result => {
            if (result.code == 0) {
              this.$emit('search', {})
              this.closeModal()
            }
          })
        }
      })
    },
    closeModal() {
      this.dialogVisible = false
      this.showLoading = false
      this.resetForm()
    },
    show() {
      this.dialogVisible = true
    },
    resetForm() {
      this.$refs['formRef'].resetFields();
    },
  }
}
</script>
